<template>
  <modal :name="modalName" height="auto" :scrollable="true">
    <form @submit.prevent="onSubmit()" :data-vv-scope="formScope">
      <div class="modal-header">
        <h5 class="modal-title">
          <span v-if="!material.id && !materialParent">New material</span>
          <span v-if="!material.id && materialParent">New material in {{materialParent.title}}</span>
          <span v-if="material.id">Edit material</span>
        </h5>
        <button type="button" class="close" @click="$modal.hide(modalName)"><i class="fas fa-times"></i></button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-12">
            <base-text :errorsNextLine="true" name="name" v-validate="'required'" label="Material name" v-model="material.name"
                       :err="errors.collect('name', formScope)"></base-text>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <base-button radius="bl" component-class="blue" @click.native="$modal.hide(modalName)">
          Close
        </base-button>
        <base-button radius="br" component-class="green filled" type="submit">
          Save
        </base-button>
      </div>
    </form>
  </modal>
</template>

<script>

  import BaseButton from '../../../../components/inputs/button/BaseButton';
  import BaseText from '../../../../components/inputs/text/BaseText';

  export default {
    name: 'ShowMaterialModal',
    components: {
      BaseButton, BaseText
    },
    data () {
      return {
        modalName: 'show-material',
        formScope: 'materialForm'
      };
    },
    methods: {
      onSubmit() {
        this.$validator.validateAll(this.formScope).then(result => {
          if (result) {
            if (this.materialParent) {
              this.material.parent_id = this.materialParent.data.id;
            }

            this.$store.dispatch('materials/save').then(() => {
              this.$modal.hide(this.modalName);
              this.$store.dispatch('materials/materials');
              this.$snotify.success('Material saved.');
            }).catch(() => {
              this.$snotify.error('Error when saving material.');
            });
          }
        });
      }
    },
    computed: {
      material: {
        get () {
          return this.$store.getters['materials/current'];
        },
        set (value) {
          this.$store.dispatch('materials/current', value);
        }
      },
      materialParent() {
        return this.$store.getters['materials/parent'];
      }
    }
  };

</script>

<style scoped>

</style>